import BulkUpdatePopup from "./component";
export default BulkUpdatePopup;
